import React from 'react';
import { addDays, format } from 'date-fns';
import { CalendarDays, MapPin, Package } from 'lucide-react';
import { formatCurrency, getDumpster, getRentalPrice, RENTAL_OPTIONS } from '../../data/dumpsters';
import type { ReservationState } from './types';
import { Separator } from '../ui/Separator';
export function OrderSummary({
  state
}: {
  state: ReservationState;
}) {
  const dumpster = getDumpster(state.sizeId);
  const rental = RENTAL_OPTIONS[state.rentalDuration];
  const pickupDate = state.deliveryDate && state.rentalDuration === 'week' ? addDays(state.deliveryDate, 7) : undefined;
  return <aside className="rounded-xl border border-border bg-secondary/40 p-5" aria-label="Order summary" data-id="element-14">
      <h3 className="text-sm font-semibold text-foreground" data-id="element-15">Order summary</h3>
      <div className="mt-4 space-y-3 text-sm" data-id="element-16">
        <div className="flex items-start gap-3" data-id="element-17">
          <Package className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-18" />
          <div data-id="element-19">
            <p className="font-medium text-foreground" data-id="element-20">
              {dumpster ? `${dumpster.name} Dumpster` : 'No size selected'}
            </p>
            <p className="text-muted-foreground" data-id="element-21">
              {rental.label}
              {dumpster ? ` · up to ${dumpster.weightLimit}` : ''}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3" data-id="element-22">
          <CalendarDays className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-23" />
          <div className="text-muted-foreground" data-id="element-24">
            {state.deliveryDate ? <>
                <p data-id="element-25">{format(state.deliveryDate, 'EEEE, MMMM d, yyyy')}</p>
                <p className="mt-0.5 text-xs" data-id="element-26">
                  {pickupDate ? `Pickup scheduled for ${format(pickupDate, 'MMM d')}` : 'We’ll coordinate pickup within your 1–3 day rental window.'}
                </p>
              </> : 'No delivery date selected'}
          </div>
        </div>
        {(state.address.street || state.address.city) && <div className="flex items-start gap-3" data-id="element-27">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-28" />
            <p className="text-muted-foreground" data-id="element-29">
              {state.address.street}
              {state.address.city && `, ${state.address.city}`}
              {state.address.state && `, ${state.address.state}`}{' '}
              {state.address.zip}
            </p>
          </div>}
      </div>
      {dumpster && <>
          <Separator className="my-4" data-id="element-30" />
          <div className="flex items-center justify-between text-base" data-id="element-31">
            <span className="font-medium text-foreground" data-id="element-32">Total</span>
            <span className="font-semibold text-foreground" data-id="element-33">
              {formatCurrency(getRentalPrice(dumpster, state.rentalDuration))}
            </span>
          </div>
          <p className="mt-1 text-xs text-muted-foreground" data-id="element-34">
            Selected {rental.days} rate. Taxes are included.
          </p>
        </>}
    </aside>;
}